import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export type ContractTypeItem = {
  id: string;
  value: string;
  isActive: boolean;
  order: number;
};

export const contractTypesApi = createApi({
  reducerPath: 'contractTypesApi',
  baseQuery: axiosBaseQuery({ baseUrl: Config.VITE_API_URL }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getContractTypes: builder.query<ContractTypeItem[], void>({
      query: () => ({ url: '/contract-types' }),
    }),
  }),
});

export const { useGetContractTypesQuery } = contractTypesApi;
